import { GuestActionDto } from "../../../networking/data/responses/GuestActionDto";
import { GuestActionType } from "../../../networking/data/responses/GuestActionType";
import { SceneIndex } from "../../SceneIndex";
import { Action } from "./Action";
import { DialogAction } from "./impl/dialogAction/DialogAction";
import { DiceRollAction } from "./impl/DiceRollAction";
import { NewsAction } from "./impl/NewsAction";
import { ScreenAction } from "./impl/ScreenAction";

export class ActionsFactory {
    public static createFromDto(dto: GuestActionDto): Action {
        ActionsFactory.streetMagic(dto);
        let action: Action;
        switch (dto.type) {
            case GuestActionType.DIALOG:
                action = new DialogAction(dto);
                break;
            case GuestActionType.DICE_ROLL:
                action = new DiceRollAction(dto);
                break;
            case GuestActionType.SCREEN:
                action = new ScreenAction(dto);
                break;
            case GuestActionType.NEWS:
                action = new NewsAction(dto);
                break;
            default:
                throw new Error(`Failed to create Action from GuestActionDto with type ${dto.type}.`);
        }
        return action;
    }

    // This method holds some general remappings for client. I introduced this fuction because we try to save some time.
    // We should probably get rid of it. Just for fun today is 25-05-2023. ;)
    private static streetMagic(dto: GuestActionDto): void {
        if (dto.type == GuestActionType.SCREEN && dto.screenType == SceneIndex.TUTORIAL) {
            // We treat this case internally as Tutorial popup above GameScene. So let's do some magic.
            dto.type = GuestActionType.DIALOG;
            dto.dialogType = SceneIndex.TUTORIAL;
            dto.screenType = undefined;
            return;
        }
    }
}